import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import CustomAccordion from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/CustomAccordion';
import { COLORS } from 'constants/design';
import expertiseExpertiseIcon from 'images/expert-expertise-icon.svg';
import MedicalFormRecap from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ExpertReport/MedicalFormRecap';
import AccountingFormRecap from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ExpertReport/AccountingFormRecap';
import { EXPERTISE_MEDICAL_ID } from 'containers/ExpertExpertise/ConcernedExpertise/constants';
import { renderTitleCustomAccordion } from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ExpertReport/utils';
import { EXPERTISE_ACCOUNTING_ID } from 'containers/CourtManagerLegalProceedings/constants';
import { formatRecapExpertise } from 'containers/ProvisionalClaimRecap/Mission/utils';

export interface ExpertiseRecapProps {
  intl: IntlShape;
  recap: any;
}
const ExpertiseRecap: React.FC<ExpertiseRecapProps> = props => {
  const renderRecapByMissionType = (item: any) => {
    if (Number(item.type) === EXPERTISE_MEDICAL_ID) {
      return (
        <MedicalFormRecap
          recap={item}
          handleOpenDialogValidation={() => {}}
          handleOpenDialogRejection={() => {}}
          handleOpenAppreciationDialog={() => {}}
          isLawyer={true}
          isTransaction={true}
          expertises={[]}
          requestGetDocByDocumentumId={() => {}}
        />
      );
    } else if (
      Number(item.type) === EXPERTISE_ACCOUNTING_ID &&
      get(item, 'mission.victims')
    ) {
      return (
        <AccountingFormRecap
          recap={item}
          handleOpenDialogValidation={() => {}}
          handleOpenDialogRejection={() => {}}
          handleOpenAppreciationDialog={() => {}}
          isLawyer={true}
          isTransaction={true}
          requestGetDocByDocumentumId={() => {}}
        />
      );
    } else {
      return <></>;
    }
  };
  return (
    <>
      {formatRecapExpertise(props.recap).map((item: any) => (
        <CustomAccordion
          title={renderTitleCustomAccordion(item)}
          textColor={COLORS.ACCORDION_TEXT_BLUE}
          bgColor={COLORS.ACCORDION_BG_BLUE}
          image={expertiseExpertiseIcon}
        >
          {renderRecapByMissionType(item)}
        </CustomAccordion>
      ))}
    </>
  );
};

export default injectIntl(ExpertiseRecap);
